import React, { Component } from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ErrorContent = styled.div`
  width: 600px;
  text-align: center;
`;

const ErrorMessage = styled.h1`
  font-size: 2rem;
  color: #ff0000;
`;

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <ErrorContainer>
                    <ErrorContent>
                        <ErrorMessage>
                            Something went wrong. Please try again later!
                        </ErrorMessage>
                        <code>Error: {this.state.error.message}</code>
                    </ErrorContent>
                </ErrorContainer>
            )
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
